export const TundrLogoVariant = {
  Light: 'light',
  Dark: 'dark',
  Small: 'small',
  SmallDark: 'small_dark',
} as const;

export type TundrLogoVariantType =
  (typeof TundrLogoVariant)[keyof typeof TundrLogoVariant];

export type TundrLogoProps = {
  id?: string;
  testId?: string;
  variant?: TundrLogoVariantType;
  clickable?: boolean;
  alt?: string;
};
